import { Component, OnInit } from '@angular/core';
import { PrivateRoutes } from 'src/app/config/config.routes';
import { scienceDTO } from 'src/app/models/science.model';
import { AppsCardComponent } from '../apps-card/apps-card.component';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-apps-cards-list',
  templateUrl: './apps-cards-list.component.html',
  styleUrls: ['./apps-cards-list.component.css'],
  imports: [AppsCardComponent],
})
export class AppsCardsListComponent implements OnInit {
  constructor(private transloco: TranslocoService) {}

  sciences: scienceDTO[] = [
    {
      title: 'Física',
      icon: '../../../assets/images/images/ic-l4p-btn.svg',
      url: PrivateRoutes.CATEGORIES,
      app: 'red',
    },
    {
      title: 'Química',
      icon: '../../../assets/images/images/ic-l4c-btn.svg',
      url: PrivateRoutes.CATEGORIES,
      app: 'purple',
    },
    {
      title: 'Biología',
      icon: '../../../assets/images/images/ic-l4b-btn.svg',
      url: PrivateRoutes.CATEGORIES,
      app: 'green',
    },
  ];
  ngOnInit(): void {
    this.sciences[0].title = this.transloco.translate('HOME.PHYSICS-TITLE');
    this.sciences[1].title = this.transloco.translate('HOME.CHEMISTRY-TITLE');
    this.sciences[2].title = this.transloco.translate('HOME.BIOLOGY-TITLE');
  }
}
